<template>
  <b-card-body>
    <h5 style="margin-top: 25px;">{{ $t('questionalternative') }}</h5>
    <div>
      <b-input-group v-for="(alternative, alternativeIndex) in question.alternatives" :key="alternativeIndex">
        <b-form-input readonly type="text" v-model="alternative.text" />
      </b-input-group>
    </div>
  </b-card-body>
</template>

<script>

export default {
  name: 'display-module-ledord',
  props: {
    question: {}
  }
}
</script>
